import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
  const {info: {theme}} = useContext(AppInfoContext)

  return (
    <svg
      width={27}
      height={27}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#clip0_2276_6977)"
        stroke={theme["#0EA59D"]}
        strokeWidth={2}
        strokeLinejoin="round"
      >
        <path d="M6.75 11.25V1.125h19.125v13.5h-4.5" />
        <path d="M16.313 10.688a2.813 2.813 0 100-5.626 2.813 2.813 0 000 5.625zM5.625 14.625h-4.5v9h4.5v-9zM5.625 15.75h9l1.125 4.5h5.704a2.17 2.17 0 011.806 3.375l-12.01 2.25L5.625 22.5M15.75 20.25h-5.625" />
      </g>
      <defs>
        <clipPath id="clip0_2276_6977">
          <path fill="#fff" d="M0 0H27V27H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
  
  export default SvgComponent